import React from "react";
import BaseCard from "@/components/cards/BaseCard";

/**
 * ServiceCard — for services index, category pages, related blocks.
 * Props: { slug, name, blurb, categoryName?, variant? }
 */
const ServiceCard = ({ slug, name, blurb, categoryName, variant = "flat" }) => (
  <BaseCard
    to={`/services/${slug}`}
    variant={variant}
    eyebrow={categoryName || "Service"}
    title={name}
    blurb={blurb}
    testid={`service-card-${slug}`}
  />
);

export default ServiceCard;
